import { gql } from '@apollo/client';

export const MARK_SATTLEMENT_COMPLETE = gql`
  mutation MarkSettlementComplete($input: MarkSettlementCompleteInput!) {
    markSettlementComplete(input: $input) {
      id
    }
  }
`;
